import { Carousel, Scrollbar } from '../core'

$.fn.PositionEventContent = function() {
  let self = this
  if (self.data('PositionEventContent')) {
    return self.data('PositionEventContent')
  }
  self.content = undefined

  self.hovered = function() {
    self.reset()
    if ($('.calendar').hasClass('calendar--grid-view')) {
      let calendar = $('.calendar-events'),
      calendarOffset = calendar.offset(),
      leftSpace = self.content.offset().left - calendar.offset().left,
      rightSpace = calendar.outerWidth(false) - self.content.outerWidth(false) - leftSpace,
      topSpace = self.content.offset().top - calendar.offset().top,
      bottomSpace = calendar.outerHeight(false) - self.content.outerHeight(false) - topSpace,
      translateX = 0, translateY = 0
      if (bottomSpace < 0) {
        translateY = '-100%'
      }
      if (rightSpace < 0) {
        translateX = '-100%'
      }
      if (translateX || translateY) {
        self.content.css('transform', 'translate(' + translateX + ', ' + translateY + ')')
      }
      leftSpace = self.content.offset().left - calendar.offset().left
      if (leftSpace < 0) {
        translateX = '-50%'
        self.content.css('transform', 'translate(' + translateX + ', ' + translateY + ')')
      }
    }
  }

  self.reset = function() {
    self.content.css('transform', '')
  }

  return function() {
    self.content = self.find('.calendar-event__content')
    self.on('mouseenter', self.hovered)
    self.data('PositionEventContent', self)
    return self
  }()
}

$.fn.Calendar = function() {
  let self = this
  self.calendarCarousel = undefined
  self.listScrollbar = undefined
  self.mobileToggleButton = self.find('.calendar-filters__toggle')
  self.filtersList = self.find('.calendar-filters__filters')
  self.filtersCheckboxes = self.find('.calendar-filters__checkbox')
  self.events = self.find('.calendar-event')

  if (self.data('calendar')) {
    return self.data('calendar')
  }

  self.init_mobile_toggle = function() {
    /* Mobile toggle */
    $.mlmi.mobile.addCallbacks(function() {
      self.mobileToggleButton.attr('aria-expanded', 'false')
      self.filtersList.hide()
      self.mobileToggleButton.on('click', function() {
        if ($(this).attr('aria-expanded') == 'false') {
          $(this).attr('aria-expanded', 'true')
          self.filtersList.slideDown(350)
        } else {
          $(this).attr('aria-expanded', 'false')
          self.filtersList.slideUp(350)
        }
      })
    }, function() {
      self.mobileToggleButton.off('click').attr('aria-expanded', 'true')
      self.filtersList.show()
    })
  }

  self.init_calendar_carousel = function() {
    self.calendarCarousel = new Carousel(self.find('.calendar-events__carousel').get(0), {
      slidesPerView: 1,
      speed: 500,
      loop: false,
      autoHeight: true,
      spaceBetween: 32,
      initialSlide: 2,
    }, {
      wrapperClass: 'calendar-events__wrapper',
      slideClass: 'calendar-events__slide',
      onInit: function() {
        self.find('.calendar-events__previous').on('click', function() {
          self.calendarCarousel.swiper.slidePrev()
        })
        self.find('.calendar-events__next').on('click', function() {
          self.calendarCarousel.swiper.slideNext()
        })
      },
      onKill: function() {
        self.find('.calendar-events__previous').off('click')
        self.find('.calendar-events__next').off('click')
      }
    })
    self.calendarCarousel.init()
    self.events.each(function() {
      $(this).find('.calendar-event__tag').SubMenuParent()
      $(this).PositionEventContent()
    })
  }

  self.init_view_toggle = function() {
    self.find('.calendar-toolbar__radio').on('change', function() {
      self.removeModifier('list-view grid-view').addModifier($(this).val())
      if ($(this).val() == 'list-view') {
        if (self.calendarCarousel != undefined) {
          self.calendarCarousel.kill(true)
          self.calendarCarousel = undefined
        }
        self.events.each(function() {
          $(this).PositionEventContent().reset()
        })
        self.listScrollbar = new Scrollbar('.calendar-events__wrapper', {
          mobile: false,
        })
      } else {
        if (self.listScrollbar != undefined) {
          self.listScrollbar.kill(true)
          self.listScrollbar = undefined
        }
        self.init_calendar_carousel()
      }
    })
  }

  self.init_filters = function() {
    self.find('input[name="event-category"]').on('change', function() {
      let currentCheckbox = $(this),
      currentValue = currentCheckbox.val(),
      currentChecked = currentCheckbox.prop('checked')
      if (currentValue == 'all' && currentChecked == false) {
        self.filtersCheckboxes.not(currentCheckbox).prop('checked', false)
      } else if (currentValue == 'all' && currentChecked == true) {
        self.filtersCheckboxes.not(currentCheckbox).prop('checked', true)
      } else if (currentChecked == false) {
        self.filtersCheckboxes.filter('[value="all"]').prop('checked', false)
      } else if (currentChecked) {
        if (self.filtersCheckboxes.filter(':checked').length >= self.filtersCheckboxes.filter('[value!="all"]').length) {
          self.filtersCheckboxes.filter('[value="all"]').prop('checked', true)
        }
      }
      let filterSlugs = self.filtersCheckboxes.map(function() {
        return ($(this).prop('checked') && $(this).val() != 'all') ? $(this).val() : null
      }).get()
      self.events.each(function() {
        let eventTerms = $(this).data('categories'),
        filteredOut = true
        eventTerms.forEach((term, i) => {
          if (filterSlugs.indexOf(term) !== -1) {
            filteredOut = false
          }
        })
        $(this).attr('aria-hidden', filteredOut ? 'true' : 'false')
      })
      if (self.listScrollbar != undefined) {
        self.listScrollbar.update()
      }
    })
  }

  self.selectToday = function() {
    var today = new Date();
    var dayWithLeadingZero = today.getDate() < 10 ? '0' + today.getDate() : today.getDate().toString();
    var month = today.getMonth()+1
    var monthWithLeadingZero = month < 10 ? '0' + month : month.toString();
    var today_string = today.getFullYear() + '-' + monthWithLeadingZero + '-' + dayWithLeadingZero
    self.find('.calendar-view__day[data-date=' + today_string + ']').addClass('--today')
  }

  return function() {
    self.BlockElement('calendar')
    self.init_mobile_toggle()
    self.init_calendar_carousel()
    self.init_view_toggle()
    self.init_filters()
    self.data('calendar', self)
    self.selectToday()
    return self
  }()
}

export default {
  init() {
    $('.calendar').each(function() {
      $(this).Calendar()
    })
  },
}
